import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { MANUAL_JOURNAL_ENTRY_API } from "./apiRoutes";

interface UseMJEDownloadTemplateProps {
  communityId: string;
  documentTypeId: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getMJEDownloadTemplate = async (communityId: string, documentTypeId: string) =>
  await axiosAuth.get(`${MANUAL_JOURNAL_ENTRY_API(communityId)}/excel-template?documentTypeId=${documentTypeId}`, {
    responseType: 'blob'
  });

const useMJEDownloadTemplate = ({
  communityId,
  documentTypeId,
  queryParams,
}: UseMJEDownloadTemplateProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["mje-download-template", communityId, documentTypeId],
    queryFn: () => getMJEDownloadTemplate(communityId, documentTypeId),
    select: (data: any) => data,
    refetchOnWindowFocus: false,
    ...queryParams,
    enabled: queryParams?.enabled,

  });
};

export default useMJEDownloadTemplate;
